export default "__VITE_ASSET__0iyI8u1E__"